import { Backdrop, Box, CircularProgress } from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import DrawerComponent from "../../components/drawerComponent/DrawerComponent";
import PageTitle from "../../components/pageTitle/PageTitle";
import ButtonSection from "./components/buttonSection/ButtonSection";
import VehicleSearchSection from "./components/vehicleSearchBoxSection/VehicleSearchSection";
import VehicleTableSection from "./components/vehicleTableSection/VehicleTableSection";
import VehiclesDeatilComponent from "./components/vehicelsDetails/VehiclesDetailComponent";
import styles from "./vehicles.module.scss";
import AddVehilceForm from "./components/addVehicleForm/AddVehilceForm";
import VehicleLogComponent from "./components/vehicleLogsComponent/VehicleLogComponent";
import i18next from "i18next";
import _ from "lodash";
import { filterVehicleList, getDealerList } from "../../services/APIService";
import { useApiErrorModalContext } from "../../errorHandling/ApiErrorModalContext";
import { useLocation, useNavigate } from "react-router-dom";
import AddDealerForm from "../Dealers/components/addDealerForm/AddDealerForm";
import DealerDetails from "../Dealers/components/dealerDetails/DealerDetails";
import DealerLogComponent from "../Dealers/components/dealerLogComponent/DealerLogComponent";

export default function Vehicles() {
  const location = useLocation();
  const defaultPageSize = 20;
  const defaultPageNumber = 1;
  const selectedDealerNumber = location?.state?.vehicleDealerNumber;
  const isBackButtonNeed = location?.state?.isBackButtonNeed;
  const dealerSelectedTab = location?.state?.dealerSelectedTab;
  const defaultVehicleListParams = {
    rows: [],
    pagination: {
      pageNumber: defaultPageNumber,
      pageSize: defaultPageSize,
      isDesc: true,
      orderBy: "lastPost"
    },
    searchValue: "",
    dealerId: selectedDealerNumber
  }


  const defaultDealerApiParam = {
    IsDesc: false,
    Status: 3,
    PageNumber: defaultPageNumber,
    PageSize: defaultPageSize,
    ...(_.get(location, "state.currentTab", 0) === 1 && { Status: 3 }),
  };
  const [dealerListApiParams, setDealerListApiParams] = useState(
    defaultDealerApiParam
  );

  const { setApiErrorModalState } = useApiErrorModalContext();
  const [vehicleList, setVehicleList] = useState([]);
  const [vehicleListParams, setVehicleListParams] = useState(
    defaultVehicleListParams
  );
  const [vehicleListResponse, setVehicleListResponse] = useState(
    defaultVehicleListParams
  );
  const [searchKeyWord, setSearchKeyWord] = useState("");
  const [sortModel, setSortModel] = useState([]);
  const [searchFlag, setSearchFlag] = useState(false);

  const [vehicelsDetails, setVehicelsDetails] = useState({});
  const [vehicleAddDrawerState, setVehicleAddDrawerState] = useState(false);
  const [editVehicleDrawerState, setEditVehicleDrawerState] = useState(false);
  const [vehicleLogsDrawerState, setVehicleLogsDrawerState] = useState(false);
  const [searchResultCount, setSearchResultCount] = useState(null);

  const [selectionModel, setSelectionModel] = useState([]);
  const [bulkActionMenuFlag, setBulkActionMenuFlag] = useState(false);

  const [vehicleDetailsDrawerState, setVehicleDetailsDrawerState] =
    useState(false);
  const [selectedVehicleNumber, setSelectedVehicleNumber] = useState(null);
  const [selectedDealerNo, setSelectedDealerNo] = useState(0);
  const [detailsDrawerState, setDetailsDrawerState] = useState(false);
  const [logDrawerState, setLogDrawerState] = useState(false);
  const [snackAssignGroupMessage, setSnackAssignGroupMessage] = useState(false);
  const [dealersList, setDealersList] = useState([]);
  const [dealersListResponse, setDealersListResponse] = useState({});
  const [exactSubcriptionList, setExactSubcriptionList] = useState([]);
  const [selectedTab, setSelectedTab] = useState(
    _.get(location, "state.currentTab", 0)
  );

  const [drawerState, setDrawerState] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [editDrawerState, setEditDrawerState] = useState(false);
  const [snackBarEditMessage, setSnackBarEditMessage] = useState(
    "A new vehicle has been added successfully"
  );
  let isLoadingDealerList = false;
  let isLoadingGroupList = false;
  let isLoadFirstTime = false;

  const [start, setStart] = useState(5);
  const history = useNavigate();

  const onBackClick = useCallback(() => {
    history("/dealers", { state: { currentTab: dealerSelectedTab } })
  }, [history]);

  const fetchVehicleList = useCallback((searchParams = vehicleListParams) => {
    setSearchFlag(true);
    filterVehicleList(searchParams)
      .then((response) => {
        if (
          !_.isEmpty(_.get(response, "errorMessage", "")) ||
          _.get(response, "success", true) === false
        ) {
          _.set(response, "status", 200);
          setSearchFlag(false);

          setApiErrorModalState({ error: response });
        } else {
          setSearchFlag(false);
          let vehicleList = _.get(response, "vehicleDtoList", []);
          setVehicleList(vehicleList);
          setVehicleListResponse(response);
          if (searchParams.hasOwnProperty("SearchTerm")) {
            setSearchResultCount(
              _.get(response, "paginationResult.totalCount", 0)
            );
          }
          window.history.replaceState(null, document.title)
        }
      })
      .catch((err) => {
        setApiErrorModalState({ error: err });
        setSearchFlag(false);
      });
  }, [vehicleListParams, setApiErrorModalState]);
  useEffect(() => {
    const searchParams = localStorage.getItem('vehicleSearchParams');    
    const stateVal = _.get(location, 'state', {})
    isLoadFirstTime = !!_.isNull(stateVal);
    if (!_.isEmpty(searchParams) && _.isNull(stateVal)) {
      const searchParam = JSON.parse(searchParams);
      setVehicleListParams(searchParam);
      setSearchKeyWord(_.get(searchParam, 'searchValue', ''));
    }
  }, [])

  useEffect(() => {
    const searchParams = localStorage.getItem('vehicleSearchParams');
    if (isLoadFirstTime) {
      if (_.isEmpty(searchParams)) {
        fetchVehicleList();
      }
    } else {
      fetchVehicleList();
      localStorage.setItem('vehicleSearchParams', JSON.stringify(vehicleListParams));
      setSearchKeyWord(_.get(vehicleListParams, 'searchValue', ''));
    }   
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vehicleListParams]);

  const toggleVehicleAddDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setVehicleAddDrawerState(!vehicleAddDrawerState);
  };

  const toggleVehicleDetailsDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setVehicleDetailsDrawerState(!vehicleDetailsDrawerState);
    setSearchFlag(true);
    fetchVehicleList();
  };

  const toggleVehicleEditDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setEditVehicleDrawerState(!editVehicleDrawerState);
  };
  const toggleVehicleLogsDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setVehicleLogsDrawerState(!vehicleLogsDrawerState);
  };

  const handleAddVehicleClick = () => {
    document.getElementById("contentWrapper").scrollIntoView();
    setSelectedVehicleNumber(0);
    setVehicleAddDrawerState(true);
    setSelectionModel([]);
    setBulkActionMenuFlag(false);
  };
  const handleCancel = (drawerType = "") => {
    switch (drawerType) {
      case "Edit": {
        setEditVehicleDrawerState(false);
        return;
      }
      case "Details": {
        setVehicleDetailsDrawerState(false);
        return;
      }
      case "Logs": {
        setVehicleLogsDrawerState(false);
        return;
      }
      case "Add":
      default: {
        setVehicleAddDrawerState(false);
        return;
      }
    }
  };
  const handleDealerCancel = (drawerType = "") => {
    switch (drawerType) {
      case "Edit": {
        setEditDrawerState(false);
        return;
      }
      case "Details": {
        setDetailsDrawerState(false);
        return;
      }
      case "Logs": {
        setLogDrawerState(false);
        return;
      }

      case "Add":
      default: {
        setDrawerState(false);
        return;
      }
    }
  };

  const handleBack = () => {
    setVehicleDetailsDrawerState(true);
    setStart(5);
    handleCancel("Logs");
  };

  const handleSearch = useCallback(
    (value, filterSearchValue) => {
      setSearchFlag(true);
      setSearchResultCount(null);

      setSearchKeyWord(value);
      if (!_.isEmpty(value) || !_.isEmpty(filterSearchValue)) {
        const searchParams = {
          ...defaultVehicleListParams,
          ...{ searchValue: value },
          ...filterSearchValue,
        }
        setVehicleListParams(searchParams);
        localStorage.setItem('vehicleSearchParams', JSON.stringify(searchParams));

      } else {
        setSearchFlag(false);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const handleTableSorting = useCallback(
    (sortingParam) => {
      if (!_.isEmpty(sortingParam)) {
        let query = sortingParam[0];
        setVehicleListParams({
          ...vehicleListParams,
          ...{
            pagination: {
              ...vehicleListParams?.pagination,
              isDesc: query?.sort === "desc",
              orderBy: query?.field,

            },
          }

        });
        setSortModel([
          {
            field: query?.field,
            sort: query?.sort,
          },
        ]);
      } else {
        vehicleListParams["OrderBy"] = "";
        setVehicleListParams({
          ...vehicleListParams,
          ...{
            pagination: {
              ...vehicleListParams?.pagination,
              isDesc: false
            },
          }
        });
        setSortModel([]);
      }
    },
    [vehicleListParams]
  );

  const fetchDealerList = useCallback(async () => {
    if (selectedTab === 0) {
      delete dealerListApiParams['Status'];
    }
    setSearchFlag(true);
    isLoadingDealerList = true;
    getDealerList(dealerListApiParams)
      ?.then((response) => {
        if (!_.isEmpty(_.get(response, "errorMessage", ""))) {
          _.set(response, "status", 200);
          setSearchFlag(false);

          setApiErrorModalState({ error: response });
        } else if (_.get(response, "success", true) === false) {
          _.set(response, "status", 200);
          setApiErrorModalState({
            error: response,
          });
          setSearchFlag(false);
        } else {
          setDealersList(_.get(response, "dealerDtoList", []));
          setDealersListResponse(response);
          if (dealerListApiParams.hasOwnProperty("SearchTerm")) {
            setSearchResultCount(
              _.get(response, "paginationResult.totalCount", 0)
            );
          }
          isLoadingDealerList = false;
          isLoadingGroupList ? setSearchFlag(true) : setSearchFlag(false);

        }
      })
      .catch((err) => {
        setSearchFlag(false);

        setApiErrorModalState({ error: err });
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dealerListApiParams, setApiErrorModalState]);


  const toggleDetailsDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setDetailsDrawerState(!detailsDrawerState);
  };
  const toggleEditDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setEditDrawerState(!editDrawerState);
  };
  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setDrawerState(!drawerState);
  };

  const toggleLogDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setLogDrawerState(!logDrawerState);
  };

  const handleDealerBack = () => {
    setStart(5);
    setDetailsDrawerState(true);
    handleCancel("Logs");
  };
  return (
    <Box className={styles.vehicleWrapper} data-testid="vehicles">
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={searchFlag}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <PageTitle
        title={`${i18next.t("Vehicles")}`}
        handleBackClick={onBackClick}
        isBackButtonNeed={isBackButtonNeed}
        data-testid="pagetitle"
      />
      <ButtonSection
        handleAddVehicleClick={handleAddVehicleClick}
        buttonList={[
          {
            title: "All vehicles",
            iconStyle: styles.listIcon,
            count: _.get(vehicleListResponse.paginationResult, "totalCount", 0),
          },
        ]}
      />
      <Box className="pageWrapper">
        <VehicleSearchSection
          vehicleList={vehicleList}
          handleChange={handleSearch}
          searchKeyword={searchKeyWord}
          count={searchResultCount}
          isBtnDisabled={searchFlag}
        />
        <VehicleTableSection
          vehiclesList={vehicleList}
          snackBarMessage={snackBarEditMessage}
          openSnackbar={openSnackbar}
          setOpenSnackbar={setOpenSnackbar}
          drawerState={setVehicleDetailsDrawerState}
          setSelectedVehicleNo={setSelectedVehicleNumber}
          setSelectedVehicleDetails={setVehicelsDetails}
          setVehicleDetailsDrawerState={setVehicleDetailsDrawerState}
          setDetailsDrawerState={setDetailsDrawerState}
          setSelectedDealerNo={setSelectedDealerNo}
          pageSize={_.get(
            vehicleListResponse,
            "paginationResult.pageSize",
            defaultPageSize
          )}
          pageNumber={_.get(
            vehicleListResponse,
            "paginationResult.currentPage",
            defaultPageNumber
          )}
          handlePageChange={(pageNo) => {

            setVehicleListParams({
              ...vehicleListParams,
              ...{
                pagination: {
                  ...vehicleListParams?.pagination,
                  pageNumber: pageNo

                },
              }
            })
          }
          }
          handlePageSizeChange={(noOfRows) =>
            setVehicleListParams({
              ...vehicleListParams,
              ...{
                pagination: {
                  ...vehicleListParams?.pagination,
                  pageSize: noOfRows

                }
              }
            })
          }
          totalRecords={_.get(
            vehicleListResponse,
            "paginationResult.totalCount",
            0
          )}
          refreshTable={() => fetchVehicleList()}
          onSortChange={(sortingParam) => handleTableSorting(sortingParam)}
          sortModel={sortModel}
          selectionModel={selectionModel}
          setSelectionModal={setSelectionModel}
          bulkActionMenuFlag={bulkActionMenuFlag}
          setBulkActionMenuFlag={setBulkActionMenuFlag}
          setSearchFlag={setSearchFlag}
        />
      </Box>
      {/* Add Drawer  */}

      <DrawerComponent
        position="right"
        toggleDrawer={toggleVehicleAddDrawer}
        drawerState={vehicleAddDrawerState}
        setDrawerState={setVehicleAddDrawerState}
        title={i18next.t("Add new vehicle")}
        contentSection={
          <AddVehilceForm
            onCancel={() => handleCancel("Add")}
            setShowMessage={setOpenSnackbar}
            setSnackBarEditMessage={setSnackBarEditMessage}
            dealerNo={0}
            vehicleId={0}
            refreshTable={() => fetchVehicleList()}
          />
        }
      />
      {/* Details Drawer  */}
      <DrawerComponent
        position="right"
        toggleDrawer={toggleVehicleDetailsDrawer}
        drawerState={vehicleDetailsDrawerState}
        setDrawerState={setVehicleDetailsDrawerState}
        title={`${i18next.t("Vehicle detail")} - ${_.get(
          vehicelsDetails,
          "make",
          "-"
        )} ${_.get(vehicelsDetails, "model", "-")} - #${_.get(
          vehicelsDetails,
          "vehicle_Id",
          "-"
        )}`}
        contentSection={
          <Box className={styles.boxWrapper}>
            <VehiclesDeatilComponent
              onCancel={() => handleCancel("Details")}
              vehicleNumber={selectedVehicleNumber}
              vehicleId={_.get(vehicelsDetails, "vehicle_Id", 0)}
              setEditDrawerState={setEditVehicleDrawerState}
              setVehicleDetailsDrawerState={setVehicleDetailsDrawerState}
              setVehicleLogsDrawerState={setVehicleLogsDrawerState}
            />
          </Box>
        }
      />
      {/* Edit Drawer  */}
      <DrawerComponent
        position="right"
        toggleDrawer={toggleVehicleEditDrawer}
        drawerState={editVehicleDrawerState}
        setDrawerState={setEditVehicleDrawerState}
        title={`Edit details`}
        contentSection={
          <AddVehilceForm
            onCancel={() => handleCancel("Edit")}
            setShowMessage={setOpenSnackbar}
            setSnackBarEditMessage={setSnackBarEditMessage}
            vehicleId={_.get(vehicelsDetails, "vehicle_Id", 0)}
            dealerNo={0}
            refreshTable={() => fetchVehicleList()}
          />
        }
      />

      {/* Vehicle Logs Drawer  */}
      <DrawerComponent
        position="right"
        toggleDrawer={toggleVehicleLogsDrawer}
        drawerState={vehicleLogsDrawerState}
        setDrawerState={setVehicleLogsDrawerState}
        title={`${i18next.t("Vehicle detail")} - ${_.get(
          vehicelsDetails,
          "make",
          "-"
        )} ${_.get(vehicelsDetails, "model", "-")} - #${_.get(
          vehicelsDetails,
          "vehicle_Id",
          "-"
        )}`}
        contentSection={
          <Box className={styles.boxWrapper}>
            <VehicleLogComponent
              onBack={() => handleBack()}
              start={start}
              setStart={setStart}
              id={_.get(vehicelsDetails, "vehicle_Id", 0)}
            />
          </Box>
        }
      />
      {/* Add Drawer  */}
      <DrawerComponent
        position="right"
        toggleDrawer={toggleDrawer}
        drawerState={drawerState}
        setDrawerState={setDrawerState}
        title={"Add new dealer"}
        contentSection={
          <Box className={styles.boxWrapper}>
            <AddDealerForm
              onCancel={() => handleCancel("Add")}
              setShowMessage={setOpenSnackbar}
              dealerNo={0}
              refreshTable={() => fetchDealerList()}
            />
          </Box>
        }
      />
      {/* Details Drawer  */}
      <DrawerComponent
        position="right"
        toggleDrawer={toggleDetailsDrawer}
        drawerState={detailsDrawerState}
        setDrawerState={setDetailsDrawerState}
        title={`${i18next.t("Dealer details")} - #${selectedDealerNo}`}
        contentSection={
          <Box className={styles.boxWrapper}>
            <DealerDetails
              onCancel={() => handleDealerCancel("Details")}
              dealerNo={selectedDealerNo}
              setEditDrawerState={setEditDrawerState}
              setDetailsDrawerState={setDetailsDrawerState}
              setLogDrawerState={setLogDrawerState}
              setSnackAssignGroupMessage={setSnackAssignGroupMessage}
              setExactSubcriptionList={setExactSubcriptionList}
            />
          </Box>
        }
      />
      {/* Edit Drawer  */}
      <DrawerComponent
        position="right"
        toggleDrawer={toggleEditDrawer}
        drawerState={editDrawerState}
        setDrawerState={setEditDrawerState}
        title={`Edit dealer`}
        contentSection={
          <Box className={styles.boxWrapper}>
            <AddDealerForm
              onCancel={() => handleDealerCancel("Edit")}
              setShowMessage={setOpenSnackbar}
              dealerNo={selectedDealerNo}
              refreshTable={() => fetchDealerList()}
              exactSubcriptionList={exactSubcriptionList}
            />
          </Box>
        }
      />

      {/* Log Drawer  */}
      <DrawerComponent
        position="right"
        toggleDrawer={toggleLogDrawer}
        drawerState={logDrawerState}
        setDrawerState={setLogDrawerState}
        title={`${i18next.t("Dealer logs")} - #${selectedDealerNo}`}
        contentSection={
          <Box className={styles.boxWrapper}>
            <DealerLogComponent
              onBack={() => handleDealerBack()}
              start={start}
              setStart={setStart}
              id={selectedDealerNo}
            />
          </Box>
        }
      />
    </Box>
  );
}
